export default __webpack_public_path__ + "static/media/crc-hold-batch-color.ad531c54.svg";